import { render, staticRenderFns } from "./FinishedVideoconsultationItem.vue?vue&type=template&id=17857910&scoped=true"
import script from "./FinishedVideoconsultationItem.vue?vue&type=script&lang=js"
export * from "./FinishedVideoconsultationItem.vue?vue&type=script&lang=js"
import style0 from "./FinishedVideoconsultationItem.vue?vue&type=style&index=0&id=17857910&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17857910",
  null
  
)

export default component.exports